import React from "react";
import "../../assets/styles/messages.css";
import thanksPageLogo from "../../assets/images/thank-you-desk.svg";
import "../../assets/styles/thankYou.css";
import BottomText from "../app/BottomText";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";

export default class ThankYou extends React.Component {
  componentDidMount() {
     sendDataLayer(gtmConstant.SecretCode.FUNNEL_STEP, {
          process_type: gtmConstant.SecretCode.PROCESS_NAME,
          step_title: gtmConstant.SecretCode.STEP_TITLE.END,
          step_number:3,
          error_type:gtmConstant.SecretCode.NA
        });
    this.refs.thanksTitle.scrollIntoView();
    this.refs.thanksTitle.focus();
  }

  render() {
    let { onShowPopup, onClosePopup, goToCalSite } = this.props;

    let thankYouWrapper = "";

    if (this.props.provider === "default") {
      thankYouWrapper = "cal message-screen-wrapper thank-you bg-t";
    } else {
      thankYouWrapper = "message-screen-wrapper thank-you bg-t";
    }

    let handleButtonClick = (action, buttonText) => {
      sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
        process_type: gtmConstant.SecretCode.PROCESS_NAME,
        step_title: gtmConstant.SecretCode.STEP_TITLE.END,
        step_number: 3,
        click_text: buttonText,
      });
    
      action();
    };

    let displayCalSite = () => {
      if (window.provider != "bit" && window.provider != "leumi") {
        return (
          <button
            aria-label={window.settings.provider.homeSiteButtonText}
            type="button"
            className="btn bg-m color-n color-nl f6 thanks pointer"
            onClick={() => handleButtonClick(goToCalSite, "יציאה")}
          >
            יציאה
          </button>
        );
      }
    };

    let displayPinForAnotherCard = () => {
      if (this.props.cards.cards) {
        if (this.props.cards.cards.length > 1) {
          return (
            <div className="btn-wrapper">
              {window.provider != "bit" ? (
                <button
                  className="btn change-card pointer"
                  type="button"
                  onClick={() => handleButtonClick(onShowPopup, "לצפייה בקוד נוסף")}
                >
                  לצפייה בקוד נוסף
                </button>
              ) : (
                ""
              )}
            </div>
          );
        }
        return <div className="btn-wrapper"></div>;
      }

      return <div className="btn-wrapper"></div>;
    };

    return (
      <div className={thankYouWrapper}>
        <div></div>
        <div className="top-section">
          <img src={thanksPageLogo} />
          <div ref="thanksTitle" className="thanks-msg">
            סיימנו פה
          </div>
          <div className="bottom-text-wrap">
            <BottomText
              onGoSecretCodeDetails={this.props.onGoSecretCodeDetails}
            />
          </div>
        </div>
        <div className="bottom-section">
          {displayPinForAnotherCard()}
          {displayCalSite()}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/ThankYou.jsx